var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavigationPointer1 = function SvgNavigationPointer1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#113628",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.273 7.163c-.397-.154-.595-.232-.653-.343a.33.33 0 0 1 0-.307c.057-.112.256-.19.652-.344l11.259-4.393c.358-.14.537-.21.651-.172.1.033.178.111.211.21.038.115-.032.294-.171.652L9.828 13.725c-.155.396-.232.595-.343.653a.33.33 0 0 1-.308 0c-.111-.059-.188-.257-.343-.654L7.082 9.22a.7.7 0 0 0-.071-.155.3.3 0 0 0-.078-.078.7.7 0 0 0-.155-.07z"
  })));
};
export default SvgNavigationPointer1;